/**
 * @fileoverview Página responsável por listar e administrar usuários da plataforma.
 */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import MainContainer from "../../components/MainContainer";
import UsersManagerModern from "../../components/UsersManager/UsersManagerModern";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.type === "light" ? "#f8fafc" : "#0A0A0A",
    minHeight: "100vh",
  },
}));

const Users = () => {
  const classes = useStyles();

  return (
    <MainContainer className={classes.root}>
      <UsersManagerModern />
    </MainContainer>
  );
};

export default Users;
